import { ArrayField } from '@measured/puck';

type IndicatorType = {
  readonly respondentType: string;
  readonly label: string;
  readonly shortLabel: string;
};

type IndicatorConfigReturn = {
  defaultValue: IndicatorType[];
  fieldConfig: ArrayField<IndicatorType[]>;
};

const createIndicatorsConfig = (respondentTypes: Set<string>): IndicatorConfigReturn => {
  return {
    defaultValue: [],
    fieldConfig: {
      arrayFields: {
        label: {
          label: 'Label',
          type: 'text',
        },
        shortLabel: {
          label: 'Short Label',
          type: 'text',
        },
        respondentType: {
          label: 'Respondent Types',
          type: 'select',
          options: [{ label: 'Select respondent type...', value: '' }].concat(
            Array.from(respondentTypes).map((respondentType) => ({
              label: respondentType,
              value: respondentType,
            }))
          ),
        },
      },
      defaultItemProps: {
        respondentType: '',
        label: '',
        shortLabel: '',
      },
      getItemSummary: ({ label }: IndicatorType) => `${label}`,
      label: 'Indicators',
      max: 4,
      min: 0,
      type: 'array',
    },
  };
};

export { createIndicatorsConfig };

export type { IndicatorType };
